import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import LoginScreen from './pages/LoginScreen';
import AuthScreen from './pages/AuthScreen';
import MotoboyHome from './pages/MotoboyHome';
import EmpresaHome from './pages/EmpresaHome';
import CentralHome from './pages/CentralHome';
import ChamadoDetalhado from './pages/ChamadoDetalhado';
import ChamadoSimplificado from './pages/ChamadoSimplificado';
import StatusPedido from './pages/StatusPedido';
import EmpresaPerfil from './pages/EmpresaPerfil';
import HistoricoEntregas from './pages/HistoricoEntregas';
import TabelaTaxas from './pages/TabelaTaxas';
import LancarEntregas from './pages/LancarEntregas';
import Configuracoes from './pages/Configuracoes';
import Mensalidades from './pages/Mensalidades';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import PaymentPending from './pages/PaymentPending';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import ListaClientes from './pages/empresa/ListaClientes';
import LoadingScreen from './components/LoadingScreen';

function App() {
  const { isLoading, isAuthenticated, userType } = useAuth();

  if (isLoading) {
    return <LoadingScreen message="Verificando autenticação..." />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/login" 
          element={!isAuthenticated ? <LoginScreen /> : <Navigate to={`/${userType?.toLowerCase()}`} replace />} 
        />
        <Route 
          path="/auth" 
          element={!isAuthenticated ? <AuthScreen /> : <Navigate to={`/${userType?.toLowerCase()}`} replace />} 
        />
        <Route 
          path="/motoboy" 
          element={isAuthenticated && userType === 'Motoboy' ? <MotoboyHome /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/empresa" 
          element={isAuthenticated && userType === 'Empresa' ? <EmpresaHome /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/central" 
          element={isAuthenticated && userType === 'Central' ? <CentralHome /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/chamado-detalhado" 
          element={isAuthenticated && userType === 'Empresa' ? <ChamadoDetalhado /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/chamado-simplificado" 
          element={isAuthenticated && userType === 'Empresa' ? <ChamadoSimplificado /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/status-pedido" 
          element={isAuthenticated && userType === 'Empresa' ? <StatusPedido /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/perfil" 
          element={isAuthenticated && userType === 'Empresa' ? <EmpresaPerfil /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/relatorio" 
          element={isAuthenticated && userType === 'Empresa' ? <HistoricoEntregas /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/tabela-taxas" 
          element={isAuthenticated && userType === 'Empresa' ? <TabelaTaxas /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/lancar-entregas" 
          element={isAuthenticated && userType === 'Empresa' ? <LancarEntregas /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/configuracoes" 
          element={isAuthenticated && userType === 'Empresa' ? <Configuracoes /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/mensalidades" 
          element={isAuthenticated && userType === 'Empresa' ? <Mensalidades /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/clientes" 
          element={isAuthenticated && userType === 'Empresa' ? <ListaClientes /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/payment/success" 
          element={isAuthenticated && userType === 'Empresa' ? <PaymentSuccess /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/payment/failure" 
          element={isAuthenticated && userType === 'Empresa' ? <PaymentFailure /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/payment/pending" 
          element={isAuthenticated && userType === 'Empresa' ? <PaymentPending /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/politica-privacidade" 
          element={<PoliticaPrivacidade />} 
        />
        <Route path="/" element={<Navigate to={isAuthenticated ? `/${userType?.toLowerCase()}` : '/login'} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

